import * as React from 'react'
import { PictureLayout } from '../image/imageLayout'
import { SponsorData } from './sponsorState'
import { Link } from 'widgets-for-react'

export type SponsorProps = {
  copy: string
  sponsorData: SponsorData
  language: string
}

export const SponsoredLayout = (p: SponsorProps) => {
  const { copy, sponsorData, language } = p

  const url = language == 'en' && sponsorData.EnglishBrandPageUrl ? sponsorData.EnglishBrandPageUrl.Url : sponsorData.UrlLink.Url

  return sponsorData.UrlField.Url ? (
    <aside className="sponsor">
      <p className="text--s">{copy}</p>
      {url ? (
        <Link
          to={url}
          title={sponsorData.Brand}
        >
          <div className="sponsor__logo">
            <span className="sr-text">{sponsorData.Brand}</span>
            <PictureLayout.Img
              image={sponsorData.UrlField}
              width="180"
              height="100"
              lazyload={false}
            />
          </div>
        </Link>
      ) : (
        <div className="sponsor__logo" title={sponsorData.Brand}>
          <span className="sr-text">{sponsorData.Brand}</span>
          <PictureLayout.Img
            image={sponsorData.UrlField}
            width="180"
            height="100"
            lazyload={false}
          />
        </div>
      )}
    </aside>
  ) : (
    <></>
  )
}
